import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api, { clearAdminSession } from "../lib/api";

export default function AdminFab() {
  const location = useLocation();
  const navigate = useNavigate();
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    let active = true;
    const verify = async () => {
      const token = sessionStorage.getItem("xs_admin_token");
      if (!token) {
        if (active) setVerified(false);
        return;
      }
      try {
        await api.get("/admin/verify");
        if (active) setVerified(true);
      } catch (error) {
        if ([401, 403].includes(error.response?.status)) clearAdminSession();
        if (active) setVerified(false);
      }
    };
    verify();
    const onAuthChanged = () => verify();
    window.addEventListener("xs-auth-changed", onAuthChanged);
    return () => {
      active = false;
      window.removeEventListener("xs-auth-changed", onAuthChanged);
    };
  }, []);

  if (!verified || location.pathname.startsWith("/admin")) return null;
  return (
    <button className="xs-admin-fab" type="button" onClick={() => navigate("/admin")} data-testid="admin-fab">
      Admin
    </button>
  );
}
